import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"

import { ROUTE_PATHS } from "../utils/routes"
import { NoWrapSpan } from "../components/styled"
import AnalyticsService from "../utils/AnalyticsService"

export const Contact = () => {

  useEffect(() => {
    AnalyticsService.sendUniquePageview(ROUTE_PATHS.CONTACT)
  },)
  return (
    <>
      <MetaTags>
        <meta property="og:title" content="Rebate & Promotions Support | T-Mobile" />
        <meta name="description" content="Need help with a T-Mobile rebate or promotion? Check submission status, view FAQs, or call customer care for device and non-device offers." />
        <link rel="alternate" hrefLang="en" href="https://promotions.t-mobile.com/contact" />
        <link rel="alternate" hrefLang="es" href="https://es.promotions.t-mobile.com/contact" />
        <link rel="canonical" href="https://promotions.t-mobile.com/contact" />
      </MetaTags>
      <section>
        <div className="container my-4">
          <div className="row">
            <div className="col-md-8 mb-4">
              <h1 className="magenta contact-tittle-font">T-Mobile Rebate & Promotions Support </h1>
              <h2 className="magenta">Rebate Frequently Asked Questions</h2>
              <p>Find quick answers about rebates, redemption, and promotional offers, <Link to={ROUTE_PATHS.FAQ}>view our Rebate FAQs</Link>.</p>
              <h2 className="magenta">Check Your Rebate Status</h2>
              <p>Already submitted a rebate? <Link to={{ pathname: process.env.REACT_APP_TMO_ID_AUTH_URL.replace("TMobileAuthCallback", "submissionstatus") }} target="_blank" rel="noreferrer">Track your rebate or promotional submission</Link>.</p>
              <h2 className="magenta">Additional Rebate Support</h2>
              <p>If you need additional help, our support teams are here:</p>
              <h3><strong>Non-Device Promotions & General Help</strong></h3>
              <ul>
                <li> Dial 611 from your T-Mobile phone, or call <a href="tel:8009378997"><NoWrapSpan>1-800-937-8997</NoWrapSpan></a></li>
                <li>Hours: 7 a.m. – 10 p.m. (local time), 7 days a week </li>
              </ul>
              <h3><strong>Device Promotions (phones, tablets, accessories)</strong></h3>
              <ul>
                <li> Call T-Mobile Promotions Customer Care:  <a href="tel:8774703619"><NoWrapSpan>1-877-470-3619</NoWrapSpan></a></li>
                <li>Hours:   </li>
                <ul>
                  <li>Monday–Friday: 8 a.m. – 10 p.m. ET</li>
                  <li>Saturday: 9 a.m. – 8 p.m. ET  </li>
                  <li>Closed Sunday</li>
                </ul>
              </ul>
              <h3><strong>Costco & Sam’s Club Member Benefit Programs  </strong></h3>
              <ul>
                <li> Dial 611 from your T-Mobile phone, or call  <a href="tel:8009378997"><NoWrapSpan>1-800-937-8997</NoWrapSpan></a></li>
                <li>Hours: 7 a.m. – 10 p.m. (local time), 7 days a week </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

Contact.propTypes = {
  history: PropTypes.object
}
